import { GET_MACHINE_RECIPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_MACHINE_RECIPES_SUCCESS: {
      const machineRecipes = action.payload;

      if (!machineRecipes){
        return [...state];
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
